import { jsx } from "react/jsx-runtime";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import { validateTidalLicense } from "../../base/index.js";
function EventRepeat(props) {
  return /* @__PURE__ */ jsx(
    EventRepeatIcon,
    {
      "data-testid": "EventRepeat",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "EventRepeat",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
EventRepeat.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "EventRepeat"
};
validateTidalLicense();
export {
  EventRepeat
};
//# sourceMappingURL=EventRepeat.js.map
